import * as ents from '@attain-apps/entities'
import { TypeChecker } from '@attain-apps/type-guards'

export interface Edge {
  recordId?: ents.core.dms.data.Record.Id
  parentId: ents.core.display.tree.Node.Id
  childId: ents.core.display.tree.Node.Id
  leaderType?: ents.extra.common.LeaderType
}
export namespace Edge {
  export const isEdge = TypeChecker.Factory.object<Edge>({
    childId: ents.core.display.tree.Node.Id.isId,
    leaderType: TypeChecker.Factory.optional(
      ents.extra.common.LeaderType.isLeaderType,
    ),
    parentId: ents.core.display.tree.Node.Id.isId,
    recordId: TypeChecker.Factory.optional(ents.core.dms.data.Record.Id.isId),
  })
}
